import { axios } from '@/utils/request'

/**
 * 应收账款明细
 * @param parameter
 * @returns {*}
 */
export function getProceedsList (parameter) {
  return axios({
    url: '/money/proceeds',
    method: 'get',
    params: parameter
  })
}

/**
 * 新增收款项目
 * @param parameter
 * @returns {*}
 */
export function addProceeds (parameter) {
  return axios({
    url: '/money/proceedsadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 新增收款项目明细
 * @param parameter
 * @returns {*}
 */
export function addProceedsItem (parameter) {
  return axios({
    url: '/money/proceedsadditem',
    method: 'post',
    data: parameter
  })
}

/**
 * 收款项目的明细记录
 * @param parameter
 * @returns {*}
 */
export function getProceedsItemsList (parameter) {
  return axios({
    url: '/money/proceedsitems',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除明细
 * @param parameter
 * @returns {*}
 */
export function deleteProceedsItem (parameter) {
  return axios({
    url: '/money/proceedsitemsdelete',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除收款项目
 * @param parameter
 * @returns {*}
 */
export function deleteProceeds (parameter) {
  return axios({
    url: '/money/proceedsdelete',
    method: 'get',
    params: parameter
  })
}

/**
 * 待支付数据
 * @param parameter
 * @returns {*}
 */
export function getPayList (parameter) {
  return axios({
    url: '/money/paylist',
    method: 'get',
    params: parameter
  })
}

/**
 * 确认支付
 * @param parameter
 * @returns {*}
 */
export function addPay (parameter) {
  return axios({
    url: '/money/payadd',
    method: 'post',
    data: parameter
  })
}